import { packingSlipSchema } from "@redotech/redo-model/packing-slips/packing-slip-definition";
import * as z from "zod/v4";

export const createPackingSlipTemplate = {
  name: "createPackingSlipTemplate" as const,
  input: z.object({
    teamId: z.string(),
    name: z.string(),
    copyFromTemplateId: z.string().optional(),
  }),
  output: packingSlipSchema,
};
